import styled from '@emotion/styled'
import { forwardRef, type HTMLAttributes } from 'react'

import { KlimbBrand } from './brand'

export interface WordmarkProps extends HTMLAttributes<HTMLSpanElement> {
  size?: number | string
}

const StyledWordmark = styled.span<{ size: number | string }>`
  font-family: var(--font-display);
  font-style: italic;
  font-weight: 400;
  font-size: ${({ size }) => (typeof size === 'number' ? `${size}px` : size)};
  letter-spacing: 0;
  line-height: 1;
  color: inherit;
`

export const Wordmark = forwardRef<HTMLSpanElement, WordmarkProps>(function Wordmark(
  { size = 22, children, ...rest },
  ref,
) {
  return (
    <StyledWordmark ref={ref} size={size} {...rest}>
      {children ?? KlimbBrand.wordmark}
    </StyledWordmark>
  )
})
